import {
  computed,
  IObservableArray,
  makeAutoObservable,
  observable,
} from "mobx";
import { SortPatternEnum } from "../Enums/SortPatternEnum";

import ResourceServerClient from "../ServerClients/ResourceServerClient";
import Fuse from "fuse.js";
import { ResourceResponseApi } from "../DTO/ServerResponseType/Resource/Resource";

const fuseOptions = {
  isCaseSensitive: false,
  shouldSort: false,
};

let fuseResourceName: Fuse<ResourceResponseApi> = new Fuse([], {
  ...fuseOptions,
  keys: ["resourceName"],
});

export class ResourcesStore {
  resources: IObservableArray<ResourceResponseApi> = observable.array([]);
  showDeleteModal: boolean = false;
  deleteResourceData?: ResourceResponseApi;
  searchPattern: string = "";
  sortPattern: SortPatternEnum = SortPatternEnum.None;
  filterType: number = -1;

  constructor() {
    makeAutoObservable(this);
  }

  onDeleteModalOpen = (resourceData: ResourceResponseApi) => {
    this.showDeleteModal = true;
    this.deleteResourceData = resourceData;
  };

  onDeleteModalClose = () => {
    this.showDeleteModal = false;
  };

  setResources = (resources: ResourceResponseApi[]) => {
    this.searchPattern = "";
    this.sortPattern = SortPatternEnum.None;
    this.resources.replace(resources);
  };

  deleteResourceAsync = async (resourceId: string) => {
    return ResourceServerClient.sendToDeleteResourceAsync(resourceId).then(
      () => {
        this.resources.replace(
          this.resources.filter(
            (resource: ResourceResponseApi) =>
              resource.resourceId !== resourceId
          )
        );
      }
    );
  };

  onChangeFilterType = (
    eventOrType: React.FormEvent<HTMLSelectElement> | number
  ): void => {
    if (typeof eventOrType === "number") this.filterType = eventOrType;
    else
      this.filterType = parseInt(
        eventOrType.currentTarget.options[
          eventOrType.currentTarget.selectedIndex
        ].value
      );
  };

  onChangeSearchPattern = (searchPattern: string) => {
    this.searchPattern = searchPattern;
  };

  onChangeSortPattern() {
    this.sortPattern =
      this.sortPattern === SortPatternEnum.None
        ? SortPatternEnum.SortAZ
        : this.sortPattern === SortPatternEnum.SortAZ
        ? SortPatternEnum.SortZA
        : SortPatternEnum.None;
  }

  @computed get filteredAndSortedAndSearchedResources(): ResourceResponseApi[] {
    let newResources: ResourceResponseApi[] = JSON.parse(
      JSON.stringify(this.resources)
    );

    // filter

    if (this.filterType !== -1)
      newResources = this.resources.filter(
        (resource) => resource.resourceTypeId === this.filterType
      );

    // searched

    // for all searched col
    if (this.searchPattern !== "") {
      fuseResourceName.setCollection(newResources);
      newResources = fuseResourceName
        .search(this.searchPattern)
        .map(({ item }) => item);
    }

    if (newResources.length === 0) return [];

    // sorted

    if (this.sortPattern !== SortPatternEnum.None)
      newResources.sort((el1, el2) => {
        let res = 0;
        res = el1.resourceName.localeCompare(el2.resourceName);
        if (this.sortPattern === SortPatternEnum.SortZA) res *= -1;

        return res;
      });

    return newResources ? newResources : [];
  }

  loadAllResourcesAsync = async (): Promise<ResourceResponseApi[] | never> => {
    return ResourceServerClient.sendToGetAllResourcesAsync().then(
      (resources) => {
        this.setResources(resources);
        return resources;
      }
    );
  };
}
